export const LABELS = {
  DELETE: 'Delete',
  UPDATE: 'Edit',
  NAME: 'Change group name',
  SAVE: 'Save',
};
